module.exports = __webpack_public_path__ + "img/aidstwo.5dff8006.svg";